import React from 'react'
import ChatBox from './components/chatbox'
import './index.scss'

// The Artemis panel beside the left icon bar. Artemis picks which sources to search for each
// question, so there are no source settings here.
const LandingPages = () => (
  <div className='left-expanded-artemis-container'>
    <ChatBox />
  </div>
)

export default LandingPages
